<form [formGroup]="configForm">
  <div class="form__field">
    <label for="header" class="input__label" i18n="@@sr_widget_config.header">Header</label>
    <input type="text" pInputText formControlName="header" />
  </div>
  <div class="form__field">
    <label for="reloadDelay" class="input__label" i18n="@@sr_widget_config.reload_delay">Reload delay (minutes)</label>
    <p-inputnumber formControlName="reloadDelay" [showButtons]="true" [min]="1" [max]="60" />
  </div>
  <div class="form__field">
    <label for="searchTerm" class="input__label" i18n="@@sr_widget_config.search_term">Search term</label>
    <input type="text" pInputText formControlName="searchTerm" />
  </div>
</form>
